import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useCocktailContext } from '@hooks';
import ProductCard from '@components/ProductCard';
import { HeaderLayout } from '@layouts';
import { ROUTES } from '@constants';
import { sortArrayByCriterion } from '@utils';
import { useStyles } from './styles';

function AdviceScreen() {
  const { t } = useTranslation('adviceScreen');
  const classes = useStyles();
  const history = useHistory();
  const { fetchedRecommendedCocktailsMap } = useCocktailContext();

  const conditionDisplayRecommendedCocktailsMap =
    Object.keys(fetchedRecommendedCocktailsMap?.results).length > 0;

  if (!conditionDisplayRecommendedCocktailsMap) {
    history.push(ROUTES.SLIDER_SCREEN, {
      from: ROUTES.ADVICE_SCREEN,
    });
  }

  const recommendedCocktailsRoundedMatch = fetchedRecommendedCocktailsMap.results.map(
    item => {
      const roundedMatch = Math.floor(item.match * 100) / 100;
      return {
        ...item,
        match: roundedMatch,
      };
    },
  );

  let sortedRecommendedCocktailsList = sortArrayByCriterion(
    recommendedCocktailsRoundedMatch,
    'match',
    'desc',
  );

  const firstMatch = sortedRecommendedCocktailsList.find(
    product => product.menuItem.promotedProduct,
  );
  sortedRecommendedCocktailsList = sortedRecommendedCocktailsList.filter(
    product => product.menuItem.name !== firstMatch.menuItem.name,
  );
  const sessionString = localStorage.getItem('session');
  const sessionParsed = JSON.parse(sessionString);

  return (
    <HeaderLayout title={t('title')}>
      <>
        <div className={classes.cocktailList}>
          <div className={classes.cocktailListInner}>
            {sessionParsed.visit.promoteProductsTestGroup === 'a' && (
              <ProductCard
                product={{ ...firstMatch.menuItem, match: firstMatch.match }}
                promoted
              />
            )}
            {conditionDisplayRecommendedCocktailsMap &&
              sortedRecommendedCocktailsList.map(advice => (
                <ProductCard
                  key={advice.menuItem.id}
                  product={{ ...advice.menuItem, match: advice.match }}
                />
              ))}
          </div>
        </div>
      </>
    </HeaderLayout>
  );
}

export default AdviceScreen;
